export default "__VITE_ASSET__a66720b7__"